/* tslint:disable */
/* eslint-disable */
export enum PayPalConfigurationStatusEnum {
  Pending = 'Pending',
  Active = 'Active'
}
